/**
 * Feito pelo agente netexperts
 * Módulo: AnalyticsObra — Tab Vendas (performance comercial / VGV + recebido / a receber)
 * Data: 2026-06-14
 */
import { useState } from 'react'
import { useObraArea } from '../hooks/useObraAnalytics'
import { DETAIL_CONFIG } from '../config/areaAnalytics'
import { formatCurrency, formatNumber, formatPercent } from '../../../../utils/obraAnalytics'
import KpiCard from '../../../../Components/Analytics/KpiCard'
import MetricCard from '../components/MetricCard'
import VendasMensalPanel from '../components/VendasMensalPanel'
import ContratosFinanceiroPanel, { CONTRATOS_POR_PAGINA } from '../components/ContratosFinanceiroPanel'
import DrillDownTable from '../components/DrillDownTable'
import TabState from '../components/TabState'

const VendasTab = ({ obraId, investidor, period = {} }) => {
    const [buscaContrato, setBuscaContrato] = useState('')
    const [contratoPage, setContratoPage] = useState(0)
    const { data, loading, error } = useObraArea(
        obraId,
        'vendas',
        {
            inicio: period.inicio,
            fim: period.fim,
            search: buscaContrato || undefined,
            page: contratoPage,
            per_page: CONTRATOS_POR_PAGINA,
        },
        investidor
    )

    if (loading || error || !data) return <TabState loading={loading} error={error} />

    const c = data.cards
    const serie = data.serieMensal ?? []
    const pag = data.contratosPaginacao || { page: 0, per_page: CONTRATOS_POR_PAGINA, total: 0, total_pages: 0 }

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                <KpiCard title="Contratos de Venda" value={formatNumber(c.num_vendas)} subtitle="Contratos no período" />
                <MetricCard title="VGV Realizado" value={c.vgv} format={formatCurrency} subtitle="Soma do VGV dos contratos" />
                <MetricCard title="Total Recebido" value={c.total_recebido} format={formatCurrency} subtitle="Caixa já recebido dos contratos" />
                <MetricCard title="Total a Receber" value={c.total_a_receber} format={formatCurrency} subtitle="Saldo pendente dos contratos" />
                <KpiCard title="% Recebido" value={formatPercent(c.pct_recebido)} subtitle="Conversão VGV → caixa" />
                <KpiCard title="Ticket Médio" value={formatCurrency(c.ticket_medio)} subtitle="VGV médio por contrato" />
            </div>

            <VendasMensalPanel serie={serie} cards={c} />

            <ContratosFinanceiroPanel
                title="Resumo por contrato de venda"
                subtitle="Divisão de recebido e a receber de cada venda no período."
                pctRecebido={c.pct_recebido}
                pctAReceber={c.pct_a_receber}
                contratos={data.contratos || []}
                paginacao={pag}
                onSearch={(term) => { setBuscaContrato(term); setContratoPage(0) }}
                onPageChange={setContratoPage}
                emptyMessage={buscaContrato ? 'Nenhum contrato encontrado para esta busca.' : 'Sem contratos no período.'}
            />

            <DrillDownTable obraId={obraId} area="vendas" investidor={investidor} config={DETAIL_CONFIG.vendas} period={period} />
        </div>
    )
}

export default VendasTab
